import { createStore } from "vuex";
import modules from "@/store/modules";

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules,
});
